module.exports = __webpack_public_path__ + "static/media/30x30.60baebd1.png";